var LEFT = 'left';
var RIGHT = 'right';
var TOP = 'top';
var BOTTOM = 'bottom';
export var POSITION = {
    LEFT: LEFT,
    RIGHT: RIGHT,
    TOP: TOP,
    BOTTOM: BOTTOM,
};
//# sourceMappingURL=position.js.map